import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CrossImg from "../../../assets/images/common/crossGroup.svg";
import CustomButton from "../../../assets/components/CustomButton";
import { setfinalizeReport } from "../../../assets/redux/actions/Quiz";
import { useNavigate } from "react-router";

export default function FinalizeReport({ showSurvay }) {
  const [show, setShow] = useState(false);
  const { finalizeReport } = useSelector(({ quiz }) => quiz);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (finalizeReport) {
      setShow(true);
    }
    return () => {
      dispatch(setfinalizeReport(null));
    };
  }, [finalizeReport]);

  const handleClose = () => {
    dispatch(setfinalizeReport(null));
    setShow(false);
  };

  const handleShowSurvay = () => {
    setShow(false);
    showSurvay();
  };

  const endMatchDialog = (
    <div className="w-100 text-center">
      <img src={CrossImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.smallTitle}>گزارش</p>
      <div className={classes.dialogContent}>
        <p className="text-right">
          با تشکر از شرکت شما در چالش جفت پوچ گزارش عملکرد شما به شرح زیر میباشد
        </p>
        {finalizeReport && (
          <>
            <div className="w-100 my-mb-2 d-flex justify-content-between align-items-center">
              <p className="mb-0">تعداد پاسخ های صحیح</p>
              <p className="mb-2 blueColor">{finalizeReport.trueAnswers}</p>
            </div>
            <div className="w-100 my-mb-2 d-flex justify-content-between align-items-center">
              <p className="mb-0">تعداد سوال</p>
              <p className="mb-0 blueColor">{finalizeReport.allowedAnswers}</p>
            </div>
            <p className="text-center mt-2 purpleColor font-weight-bold">
              دستاورد ها
            </p>
            <div className="w-100 my-mb-2 d-flex justify-content-between align-items-center">
              <p className="mb-0">طبقه</p>
              <p className="mb-0 blueColor">{finalizeReport.userLevel}</p>
            </div>
            <div className="w-100 my-mb-2 d-flex justify-content-between align-items-center">
              <p className="mb-0">پله ها</p>
              <p className="mb-0 blueColor">
                {finalizeReport.quizScoreCollected}
              </p>
            </div>
            <div className="w-100 my-mb-2 d-flex justify-content-between align-items-center">
              <p className="mb-0">کلید ها</p>
              <p className="mb-0 blueColor">{finalizeReport.quizCoin}</p>
            </div>
          </>
        )}
      </div>
      <div className="w-100 mt-4">
        <CustomButton
          clickHandler={() => navigate("/leaderboard")}
          color={"primary"}
          shadow
          text={"جدول پیشتازان"}
        />
        <CustomButton
          clickHandler={handleShowSurvay}
          color={"secondary"}
          shadow
          text={"به نظرت آزمون چطور بود؟"}
          styles={{ marginTop: "16px" }}
        />
      </div>
    </div>
  );

  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={endMatchDialog}
    />
  );
}
